import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import CustomAutomationButton from './custom-automations-buttons'
const LogoView = props => {
  const {
    logo,
    productName,
    buttonClass,
    buttonUrl,
    logoHeight,
    classes,
  } = props
  const buttonsClass = classes[buttonClass]
  const onClick = () => {
    window.open(buttonUrl, '_blank')
  }
  return (
    <div className={classes.root}>
      <div className={classes.root__img}>
        <img src={logo} height={logoHeight} alt=""></img>
      </div>
      <Typography textAlign={'center'}>
        Sign-in to your <br />
        {productName} account
      </Typography>
      <CustomAutomationButton onClick={onClick} buttonsClass={buttonsClass} />
    </div>
  )
}

export default withStyles(styles)(LogoView)
